import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

import {
  mediumWidth,
  smallWidth,
  ageWidth,
  largeWidth,
} from '../../../Constants';
import { numberToStringWithCommas } from '../../../helpers/NumberFormatting';
import {
  getIntelAgeWithToolTip,
  hoursMinutesFromSeconds,
  numberWithCommasComparator,
} from '../helpers/colHelpers';

export const armyGridColDefinitions: GridColDef[] = [
  { field: 'id', headerName: 'id_army', width: 20 },
  { field: 'pid', headerName: '#', width: 20 },
  {
    field: 'name',
    headerName: 'Name',
    width: 200,
    sortable: false,
    valueGetter: (value, row) => row.name,
  },
  {
    field: 'secondsRemaining',
    headerName: 'TimeRemaining',
    width: 90,
    sortable: false,
    valueGetter: (value, row) => row.secondsRemaining,
    renderCell: (params: GridRenderCellParams) =>
      hoursMinutesFromSeconds(params.row.secondsRemaining),
  },
  {
    field: 'acres',
    headerName: 'Acres',
    width: mediumWidth,
    valueGetter: (value, row) => numberToStringWithCommas(row.land),
    sortComparator: numberWithCommasComparator,
  },
  {
    field: 'ambush',
    headerName: 'Ambush',
    width: largeWidth,
    sortable: false,
    valueGetter: (value, row) => numberToStringWithCommas(row.ambush),
  },
  {
    field: 'generals',
    headerName: 'Gen',
    width: smallWidth,
    sortable: false,
    valueGetter: (value, row) => numberToStringWithCommas(row.generals),
  },
  {
    field: 'soldiers',
    headerName: 'Solds',
    width: mediumWidth,
    sortable: false,
    valueGetter: (value, row) => numberToStringWithCommas(row.solds),
  },
  {
    field: 'oSpecs',
    headerName: 'OSpecs',
    width: mediumWidth,
    sortable: false,
    valueGetter: (value, row) => numberToStringWithCommas(row.oSpecs),
  },
  {
    field: 'Elites',
    headerName: 'Elites',
    width: mediumWidth,
    sortable: false,
    valueGetter: (value, row) => numberToStringWithCommas(row.elites),
  },
  {
    field: 'Horses',
    headerName: 'Horses',
    width: mediumWidth,
    sortable: false,
    valueGetter: (value, row) => numberToStringWithCommas(row.horses),
  },
  {
    field: 'rawOff',
    headerName: 'RawOff',
    width: ageWidth,
    valueGetter: (value, row) => numberToStringWithCommas(row.rawOff),
  },
  {
    field: 'modOff',
    headerName: 'ModOff',
    width: ageWidth,
    valueGetter: (value, row) => numberToStringWithCommas(row.modOff),
  },
  {
    field: 'rawDef',
    headerName: 'RawDef',
    width: ageWidth,
    valueGetter: (value, row) => numberToStringWithCommas(row.rawDef),
  },
  {
    field: 'modDef',
    headerName: 'ModDef',
    width: ageWidth,
    valueGetter: (value, row) => numberToStringWithCommas(row.modDef),
  },
  {
    field: 'somAge',
    headerName: 'SomAge',
    width: ageWidth,
    renderCell: (params: GridRenderCellParams) =>
      getIntelAgeWithToolTip(params.row.ageSeconds, 'SOM'),
  },
];
